'use client';

import { IconSize } from '@diamond-block/ui';
import { signIn, signOut, useSession } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { TbCaretDown, TbLogin, TbLogout, TbUser } from 'react-icons/tb';

export const AccountMenu = () => {
  const t = useTranslations('AccountMenu');
  const { status, data: session } = useSession();

  return (
    <>
      {status === 'authenticated' && (
        <div className="dropdown dropdown-end dropdown-hover">
          <div
            tabIndex={0}
            role="button"
            className="btn btn-ghost max-md:btn-square"
          >
            <TbUser size={IconSize.btn} />
            <span className="max-md:hidden">{session.user?.name}</span>
            <TbCaretDown className="max-md:hidden" />
          </div>
          <ul
            tabIndex={0}
            className="menu dropdown-content rounded-box bg-base-100 dark:bg-base-200 text-base-content z-2 min-w-48 p-2 shadow-sm"
          >
            <li>
              <span className="menu-title">{session.user?.name}</span>
            </li>
            <li>
              <a
                onClick={() =>
                  signOut({
                    redirectTo: '/',
                  })
                }
              >
                <TbLogout size={IconSize.dropdownItem} /> {t('logout')}
              </a>
            </li>
          </ul>
        </div>
      )}
      {status === 'unauthenticated' && (
        <button className="btn btn-ghost" onClick={() => signIn('keycloak')}>
          <TbLogin size={IconSize.btn} /> {t('login')}
        </button>
      )}
      {status === 'loading' && (
        <div className="btn btn-ghost">
          <span className="loading loading-spinner loading-xs"></span>
          {t('loading')}
        </div>
      )}
    </>
  );
};
